import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { AuthenticationService } from "../services/auth.service";

@Injectable({
  providedIn: "root"
})
export class RolesGuard implements CanActivate {
  can: boolean = true;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  async canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const user = this.authenticationService.getCurrentUser();

    this.router.events.subscribe((data: any) => {
      if (data && data.snapshot && data.snapshot.data && data.snapshot.data.permission) {
        if (data.snapshot.data.permission.indexOf(user.roles) === -1) {
          this.can = false;

          // if (user.roles === "ADMINISTRADOR") {
          //   return this.router.navigate(['/dashboard']);
          // } else {
          //   return this.router.navigate(['/dashboard-manager']);
          // }
        }
        this.can = true;
      }
    });

    return this.can;
  }
}
